// extracted by mini-css-extract-plugin
export default {"pageTitle":"page-title_pageTitle__t2N9E"};